// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Rm-","right":"styles_right__Z_k6s"};